/**
 * Администратор компании -- пользователь с правом administration.write.
 *
 * Изменения настроек, интеграций, сенсоров и команды бэкенд разрешает только ему
 * (@RequiresPermission(ADMINISTRATION_WRITE) и @RequiresRole("ADMIN") по актуальной
 * роли из состояния сессии). Интерфейс по тому же праву прячет кнопки изменения и
 * не пускает на адреса форм (AdminRoute в src/router/guards.tsx): форма, которую
 * нельзя сохранить, только сбивала бы с толку. Права выдаёт сервер; строка роли
 * сама по себе ничего не разрешает.
 */

import type { User } from '@/api/types';
import { hasPermission } from '@/auth/permissions';
import { useSessionStore } from '@/stores/session';

/** Администратор ли пользователь; без сессии или без прав -- нет */
export function isAdminUser(user: User | null | undefined): boolean {
	return hasPermission(user?.capabilities, 'administration.write');
}

/** Администратор ли текущий пользователь сессии */
export function useIsAdmin(): boolean {
	return useSessionStore((s) => isAdminUser(s.user));
}
